var Dialog = {
  defaultProps: {
    palette: 'secondary'
  }
};

export default Dialog;
